/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import SelectField from "components/SelectField";

export default function CapitalTransfer06() {
  const { formId, formField } = form;

  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([]);

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai số thu từ chênh lệch vốn chủ sở hữu lớn hơn vốn điều lệ tại doanh nghiệp -
                Mẫu 01/CLVCSH-VDL
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    from,
    firstTime,
    mst,
    strangeFrom,
    strangeTo,
    time,
    // capitalTransfer,
    // transferofsharePurchaseRights,
    // differentAgreedMethod,
    // agreedMethod,
    // transferOfCapitalContributionRights,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        {/* <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name={capitalTransfer.name}
            label={capitalTransfer.label}
            value={values.capitalTransfer}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name={transferofsharePurchaseRights.name}
            label={transferofsharePurchaseRights.label}
            value={values.transferofsharePurchaseRights}
          />
        </Grid> */}
        {/* <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={agreedMethod.name}
            label={agreedMethod.label}
            value={values.agreedMethod}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={differentAgreedMethod.name}
            label={differentAgreedMethod.label}
            value={values.differentAgreedMethod}
          />
        </Grid> */}
        {/* <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name={transferOfCapitalContributionRights.name}
            label={transferOfCapitalContributionRights.label}
            value={values.transferOfCapitalContributionRights}
          />
        </Grid> */}
        {/* <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={from.name}
            label={from.label}
            value={values.from}
            error={errors.from && touched.from}
            success={values.from?.toString().length > 0 && !errors.from}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={mst.name}
            label={mst.label}
            value={values.mst}
            error={errors.mst && touched.mst}
            success={values.mst?.toString().length > 0 && !errors.mst}
          />
        </Grid> */}
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={strangeFrom.name}
            label={strangeFrom.label}
            value={values.strangeFrom}
            error={errors.strangeFrom && touched.strangeFrom}
            success={values.strangeFrom?.toString().length > 0 && !errors.strangeFrom}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={strangeTo.name}
            label={strangeTo.label}
            value={values.strangeTo}
            error={errors.strangeTo && touched.strangeTo}
            success={values.strangeTo?.toString().length > 0 && !errors.strangeTo}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={firstTime.company} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={time.name}
            label={time.label}
            value={values.time}
            error={errors.time && touched.time}
            success={values.time?.toString().length > 0 && !errors.time}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayers.name}
            label={taxpayers.label}
            value={values.taxpayers}
            error={errors.taxpayers && touched.taxpayers}
            success={values.taxpayers?.toString().length > 0 && !errors.taxpayers}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxCode.name}
            label={taxCode.label}
            value={values.taxCode}
            error={errors.taxCode && touched.taxCode}
            success={values.taxCode?.toString().length > 0 && !errors.taxCode}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentCode.name}
            label={taxAgentCode.label}
            value={values.taxAgentCode}
            error={errors.taxAgentCode && touched.taxAgentCode}
            success={values.taxAgentCode?.toString().length > 0 && !errors.taxAgentCode}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
